import * as React from 'react';
import { noop } from 'vet-bones/utils';

import { Suggestion } from 'src/containers/ProjectMapping/types';

export type MappingSuggestion = {
  name: string;
  resourceId: string;
  classIri: string;
  classLabel: string;
  isClassAutoCreated: boolean;
  isExpanded: boolean;
  suggestions: Suggestion[];
};

export type ProjectResourceSuggestionsData = {
  selectedClasses: string[];
  selectedResources: string[];
  setSelectedClasses: React.Dispatch<React.SetStateAction<string[]>>;
  setSelectedResources: React.Dispatch<React.SetStateAction<string[]>>;
};

export const ProjectResourceSuggestionsDataContext =
  React.createContext<ProjectResourceSuggestionsData>({
    selectedClasses: [],
    selectedResources: [],
    setSelectedClasses: noop,
    setSelectedResources: noop,
  });

export const useProjectResourceSuggestionsData = () =>
  React.useContext(ProjectResourceSuggestionsDataContext);
